import {
    FETCH_BRAND_BEGIN,
    FETCH_BRAND_SUCCESS,
    UPDATE_BRAND_BEGIN,
    UPDATE_BRAND_FAILURE,
    UPDATE_BRAND_SORT
} from '../actions/brandActions';

const initialState = {
    brand: {
        verticals: []
    },
    campaign: [],
    sort_col: false,
    sort_dir: false,
    loading: false,
    error: null,
    errors: []
};

export default function brandReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_BRAND_SUCCESS:
            return {
                ...state,
                brand: action.payload.result.brand,
                campaign: action.payload.result.campaigns,
                loading: false,
                errors: [],
                error: false,
                permission: action.payload.result.permission
            };

        case FETCH_BRAND_BEGIN:
            return {
                ...state,
                loading: true
            };

        case UPDATE_BRAND_BEGIN:
            return {
                ...state,
                loading: true,
                errors: [],
                error: false
            };

        case UPDATE_BRAND_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
            };

        case UPDATE_BRAND_SORT:
            return {
                ...state,
                sort_col: action.payload.sort_col,
                sort_dir: action.payload.sort_dir
            };

        default:
            return state;
    }
}
